import React, {
  ReactElement, ReactNode, useEffect, useState,
} from 'react'
import styled, { CSSObject } from 'styled-components'
import { addClasses } from '../../helpers/dataTransformer'
import colors from '../../lib/colors'

const Styles = styled.div`
  position: relative;
  background-color: ${colors.white};
  color: ${colors.black};
  border-radius: 5px;
  margin: 20px auto;

  p {
    margin-top: 0;
  }
  width: fit-content;
  &.card-size-full {
    max-width: 1800px;
    width: auto;
  }
  &.card-size-big {
    width: 1100px;
    width: ${(props): string => props.theme.breakpoint && 'auto'};
  }
  &.card-size-medium {
    max-width: 860px;
    width: 860px;
    width: ${(props): string => props.theme.breakpoint && 'auto'};
  }
  &.card-size-small {
    max-width: 450px;
    width: 450px;
  }
`
export enum CardSize {
  Full = 'full',
  Big = 'big',
  Medium = 'medium',
  Small = 'small',
}
interface CardProps {
  children: ReactNode
  className?: string
  cardSize?: CardSize
  style?: CSSObject
}
function Card(props: CardProps): ReactElement {
  const {
    children, className, cardSize, style,
  } = props

  const MAX_SMALL_DESKTOP = 1399
  const checkBreakpoint = (): boolean => {
    if (window.innerWidth < MAX_SMALL_DESKTOP) return true
    return false
  }

  const [breakpoint, setBreakpoint] = useState(checkBreakpoint)

  useEffect(() => {
    const handleResize = (): void => setBreakpoint(checkBreakpoint)

    window.addEventListener('resize', handleResize)
    return (): void => window.removeEventListener('resize', handleResize)
  }, [])

  const classes = addClasses(className, `card-size-${cardSize}`)

  return (
    <Styles
      className={classes}
      style={style}
      theme={{ breakpoint }}
    >
      {children}
    </Styles>
  )
}
export default Card
